import { InvoiceStatusRenderer } from '../../billings/invoices/InvoiceStatusRender';

import type { TFunction } from 'i18next';

export const getInvoiceHistoryColumns = (t: TFunction<'invoice'>) => [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: string) => {
        return InvoiceStatusRenderer(value, t);
      },
    },
  },
  {
    name: 'created_by',
    label: 'Created by',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'billed_to',
    label: 'Billed to',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'client_name',
    label: 'Client',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'invoice_id',
    label: 'Invoice ID',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'amount_billed',
    label: 'Amount billed',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'amount_due',
    label: 'Amount due',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'date_sent',
    label: 'Date sent',
    options: {
      filter: false,
      sort: false,
    },
  },
];
